export default __webpack_public_path__ + "static/media/food-gif.165ae08c.gif";